import React from "react";
import "../App.css";

function Loader() {
  return <div className="loader"></div>;
}

export default Loader;
